import { createContext, useContext } from 'react';
import type { Contract } from '@omq/types';

/**
 * Type of contract context.
 */
type ContractContextType = {
  contract: Contract;
};

/**
 * Type of component properties.
 */
type ContractWrapperProps = {
  children: JSX.Element;
};

// create (react) context
const ContractContext = createContext<ContractContextType>({} as any);

// provide hook to access context
export const useContractContext = (): ContractContextType => {
  const context = useContext(ContractContext);
  if (context == null) {
    throw new Error(
      'ContractContext is null - Did you forget to wrap your component with ContractWrapper?',
    );
  }

  return context;
};

/**
 * Component that wraps passed children in context provider.
 *
 * @param {JSX.Element} children - children to render
 *
 * @returns {JSX.Element}
 */
export const ContractWrapper = ({ children }: ContractWrapperProps): JSX.Element => {
  // create context value object
  const contractContextValue = {
    contract: window.defaultData.contract,
  };

  // render context provider
  return (
    <ContractContext.Provider value={contractContextValue}>{children}</ContractContext.Provider>
  );
};
